// Drag a sound out to a DAW or the Finder (SI-11, d36, d45). Chromium's
// DownloadURL drag carries one file: free or owned sounds only, from
// anywhere on the row. Every drag of ours also carries
// application/x-cloudloop-sound (the hash), so dropping it back on
// cloudloop starts nothing (d43). Other browsers don't drag a file.
//   onDragStart(event, sound)   from a row's dragstart
import { canDownload, soundFileName } from "@/kit/sound.js";
import { getWavDownloadFromProxyWithId } from "@/filters/utils";

export const OWN_DRAG_TYPE = "application/x-cloudloop-sound";

// Chromium (Chrome, Edge, Opera, Brave): the only browsers with DownloadURL.
export function supportsDownloadUrl() {
  if (typeof navigator === "undefined") return false;
  const brands = navigator.userAgentData && navigator.userAgentData.brands;
  if (Array.isArray(brands) && brands.some((b) => /Chromium/i.test(b.brand))) return true;
  const ua = navigator.userAgent || "";
  return /Chrome\//.test(ua) && !/Firefox/.test(ua);
}

// An absolute download URL with the sound's token.
export function downloadUrlFor(sound) {
  const url = getWavDownloadFromProxyWithId(sound.hash, sound.downloadToken);
  try {
    return new URL(url, window.location.href).href;
  } catch (e) {
    return url;
  }
}

// "audio/wav:Dusty pad_88_E.wav:https://…/download?id=…&token=…"
export function downloadUrlData(sound) {
  return `audio/wav:${soundFileName(sound)}:${downloadUrlFor(sound)}`;
}

// True when a drag is one of ours (drop targets ignore it).
export function isOwnDrag(event) {
  const types = event && event.dataTransfer && event.dataTransfer.types;
  return !!types && Array.from(types).includes(OWN_DRAG_TYPE);
}

/** Fill a dragstart; returns whether a file rides along. */
export function onDragStart(event, sound) {
  const dt = event && event.dataTransfer;
  if (!dt || !sound) return false;
  dt.setData(OWN_DRAG_TYPE, sound.hash);
  if (!canDownload(sound) || !supportsDownloadUrl()) return false;
  dt.effectAllowed = "copy";
  dt.setData("DownloadURL", downloadUrlData(sound));
  return true;
}

export default { onDragStart, isOwnDrag, downloadUrlData, supportsDownloadUrl, OWN_DRAG_TYPE };
